// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

import { useI18nContext } from '@/contexts/i18n';

export function useI18n() {
  return useI18nContext();
}
